import { Transform, Type } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';
import { PagingSearchFieldArgument } from 'src/lib/utilities/api/patterns/pagination/paging-search-field.argument';

export class CurriculumCatalogSubjectAreaModel {
	subject_area_id: number;
	title: string;
	short_code: string;
	base_area_ids: number[];
}

export function CurriculumCatalogSubjectAreaModel_ClassTransform_Type() {
	return CurriculumCatalogSubjectAreaModel;
}

export class CurriculumCatalogSectionModel {
	section_id: number;
	title: string;
	course_id: number;
	version_id: number;
	version_code: string;
	version_title: string;
	term: number;
	term_type: string;
	credits: number;
	suggestion_ranking: number;
	overridden_suggestion_ranking: number;
	base_suggestion_ranking: number;
}

export function CurriculumCatalogSectionModel_ClassTransform_Type() {
	return CurriculumCatalogSectionModel;
}

export class CurriculumCatalogCourseModel {
	course_id: number;
	title: string;
	course_number: string;
	subject_areas: number[];
}

export function CurriculumCatalogCourseModel_ClassTransform_Type() {
	return CurriculumCatalogCourseModel;
}

export class CurriculumCatalogAssociationsModel {
	student_count: number;
	graduation_plan_count: number;
	is_deletable: boolean;
}

export function CurriculumCatalogAssociationsModel_ClassTransform_Type() {
	return CurriculumCatalogAssociationsModel;
}

export class CurriculumCatalogModel {
	id: number;
	title: string;
	default_program_group: string;
	program_ids: number[];
	@Transform(dateTransformer)
	created_date: Date;
	@Transform(dateTransformer)
	last_edited_date: Date;
	@Transform(dateTransformer)
	deactivation_date: Date;
	@Type(CurriculumCatalogSubjectAreaModel_ClassTransform_Type)
	subject_areas: CurriculumCatalogSubjectAreaModel[];
	@Type(CurriculumCatalogSectionModel_ClassTransform_Type)
	sections: CurriculumCatalogSectionModel[];
	@Type(CurriculumCatalogCourseModel_ClassTransform_Type)
	courses: CurriculumCatalogCourseModel[];
	@Type(CurriculumCatalogAssociationsModel_ClassTransform_Type)
	associations: CurriculumCatalogAssociationsModel;
}

export class CurriculumCatalogSearchItemModel {
	id: number;
	title: string;
	section_count: number;
	program_count: number;
	graduation_plan_count: number;
	student_count: number;
	@Transform(dateTransformer)
	created_date: Date;
	@Transform(dateTransformer)
	last_edited_date: Date;
	@Transform(dateTransformer)
	deactivated_date: Date;
	program_names: string[];
}

export function CurriculumCatalogSearchItemModel_ClassTransform_Type() {
	return CurriculumCatalogSearchItemModel;
}

export class CurriculumCatalogSearchResultModel {
	@Type(CurriculumCatalogSearchItemModel_ClassTransform_Type)
	results: CurriculumCatalogSearchItemModel[];
	count: number;
}

export interface CurriculumCatalogSearchArgument {
	id: PagingSearchFieldArgument;
	title: PagingSearchFieldArgument;
	section_count: PagingSearchFieldArgument;
	program_count: PagingSearchFieldArgument;
	graduation_plan_count: PagingSearchFieldArgument;
	student_count: PagingSearchFieldArgument;
	created_date: PagingSearchFieldArgument;
	last_edited_date: PagingSearchFieldArgument;
	deactivated_date: PagingSearchFieldArgument;
	program_names: PagingSearchFieldArgument;
}

export interface CurriculumCatalogUpsertArgument {
	title: string;
	default_program_group: string;
	sections: { add?: number[]; remove?: number[] };
	program_ids?: number[];
}

export interface CatalogUpsertSubjectAreaArgument {
	title: string;
	short_code: string;
	base_area_ids: number[];
}
